import { render, staticRenderFns } from "./selectRemittanceType.vue?vue&type=template&id=1514897c&scoped=true"
import script from "./selectRemittanceType.vue?vue&type=script&lang=js"
export * from "./selectRemittanceType.vue?vue&type=script&lang=js"
import style0 from "./selectRemittanceType.vue?vue&type=style&index=0&id=1514897c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1514897c",
  null
  
)

export default component.exports